import React, { useState, useEffect } from 'react';
import Modal from '../../../common/components/Modal/modal';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import { useFormik } from 'formik';
import { slabDiv, slabContainer } from './AddCommission.module.css';
import InputTypeFloat from '../../../common/components/InputTypeDecimalNumber/InputTypeFloat';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddLine from '../../../images/icons/addLine.svg';
import {
  getBankUnitListAPI,
  getProductByGroupId,
  getProductGroup,
  createCommisssion
} from '../../../common/constants/api';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import * as _ from 'lodash';
import PopUp from '../../../common/components/PopUp/PopUp';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';

const modalStyle = {
  maxWidth: '600px',
  minWidth: '250px',
  maxHeight: '90%',
  minHeight: '60%'
};

const AddCommission = ({
  showModal,
  setShowModal,
  fiUnit,
  setCurrUnitSelected
}) => {
  const [lines, setLines] = useState(1);
  const [zoneLoadedStatus, setZoneLoadedStatus] = useState(null);
  const [productGroupLoadStatus, setProductGroupLoadStatus] = useState(null);
  const [productLoadStatus, ProductLoadStatus] = useState(null);
  const [zoneList, setZoneList] = useState([]);
  const [productGroup, setProductGroup] = useState([]);
  const [products, setproducts] = useState([]);
  const [show, setShow] = useState(false);
  const [text, setText] = useState('loading...');
  const [type, setType] = useState('loading');

  const validate = values => {
    const errors = {};
    if (!values?.applicable_zone?.value) errors.applicable_zone = 'Required';
    if (!values?.productGroup?.value) errors.productGroup = 'Required';
    Array(lines)
      .fill()
      .forEach((each, i) => {
        if (
          formik?.values[`from${i}`] &&
          formik?.values[`to${i}`] &&
          parseFloat(formik?.values[`to${i}`]) <=
            parseFloat(formik?.values[`from${i}`])
        ) {
          errors[`to${i}`] = 'it seems to be wrong ';
        }
        if (formik?.values[`from${i}`] && !formik?.values[`to${i}`]) {
          errors[`to${i}`] = 'required';
        }
        if (!formik?.values[`from${i}`] && formik?.values[`to${i}`]) {
          errors[`from${i}`] = 'required';
        }
        if (
          (formik?.values[`from${i}`] || formik?.values[`to${i}`]) &&
          !formik?.values[`comm${i}`]
        ) {
          errors[`comm${i}`] = 'required';
        }
      });

    return errors;
  };
  const formik = useFormik({
    initialValues: {
      applicable_zone: {
        label: 'Units',
        value: ''
      },
      product: {
        label: 'Product',
        value: ''
      },
      productGroup: {
        label: 'Product Group',
        value: ''
      },
      from0: '0'
    },
    validate: validate
  });

  const selectFiledCommonFormikFunction = name => {
    if (!name || typeof name != 'string') return;

    return {
      name: name,
      error:
        formik?.touched[name.toString()] &&
        _.get(formik?.errors, `${name}`, false),
      touched: formik?.touched[name.toString()],
      value: formik?.values[name],
      onChange: e =>
        formik?.setFieldValue(name, {
          value: e.value,
          label: e.label
        }),
      onBlur: () => formik?.setFieldTouched(name, true, true)
    };
  };

  const selectBoxCommonStyle = isDisabled => {
    return {
      dropdownStyle: {
        top: '52px',
        fontSize: '16px'
      },
      stylesContainer: {
        height: '52px',
        ...(isDisabled ? { opacity: '0.5' } : {})
      },
      styleText: {
        fontSize: '14px',
        padding: '0 20px'
      }
    };
  };
  const commonFormikFunction = name => {
    return {
      name: name,
      onBlur: formik?.handleBlur,
      value: formik?.values[name.toString()],
      error:
        formik?.errors[name.toString()] && formik?.touched[name.toString()],
      errorMsg: formik?.errors[name.toString()],
      touched: formik?.touched[name.toString()],
      setFieldValue: formik?.setFieldValue,
      legendStyle: {
        color: '#989898'
      }
    };
  };
  /*zone list api */
  const loadZoneList = () => {
    setZoneLoadedStatus('loading');
    getBankUnitListAPI(fiUnit)
      .then(res => {
        if (
          res.error ||
          !res?._embedded?.financialUnitDetailDtoList?.length > 0
        )
          throw new Error(res);

        setZoneList(
          res?._embedded?.financialUnitDetailDtoList?.map(each => {
            return { label: each?.unitName, value: each?.id };
          })
        );
        setZoneLoadedStatus('loaded');
      })
      .catch(error => {
        setZoneLoadedStatus('failed');
      });
  };
  /* product group api */
  const loadProductGroup = () => {
    setProductGroupLoadStatus('loading');
    getProductGroup()
      .then(res => {
        if (res.error) throw new Error(res);
        setProductGroup(
          res?.map(each => {
            return { label: each.name, value: each.id };
          })
        );
        setProductGroupLoadStatus('loaded');
      })
      .catch(error => {
        setProductGroupLoadStatus('failed');
      });
  };

  /* get list of product by Product group Id */
  const loadProductsListByGroupId = groupId => {
    ProductLoadStatus('loading');
    getProductByGroupId(groupId)
      .then(res => {
        if (res.error) throw new Error(res);
        setproducts(
          res?.map(each => {
            return { label: each.displayName, value: each.id };
          })
        );
        ProductLoadStatus('loaded');
      })
      .catch(error => {
        ProductLoadStatus('failed');
      });
  };

  useEffect(() => {
    if (!showModal) return;
    loadZoneList();
    loadProductGroup();
  }, [showModal]);

  useEffect(() => {
    if (!formik?.values?.productGroup?.value) return;
    loadProductsListByGroupId(formik?.values?.productGroup?.value);
  }, [formik?.values?.productGroup?.value]);

  const getbody = () => {
    let listofComm = [];
    for (let i = 0; i < lines; i++) {
      if (
        !formik?.values[`from${i}`] ||
        !formik?.values[`to${i}`] ||
        !formik?.values[`comm${i}`]
      )
        continue;
      listofComm.push({
        minAmount: formik?.values[`from${i}`] * 10000000,
        maxAmount: formik?.values[`to${i}`] * 10000000,
        commissionPercentage: parseFloat(formik?.values[`comm${i}`])
      });
    }

    return {
      unitId: formik?.values?.applicable_zone?.value,
      productGroupId: formik?.values?.productGroup?.value,
      productId: formik?.values?.product?.value || '',
      maxCapping: formik?.values?.max_cap
        ? parseInt(parseFloat(formik?.values?.max_cap) * 100000)
        : null,
      allCommissionAmountDto: listofComm
    };
  };

  const handleSubmit = () => {
    if (Object.keys(formik?.errors).length > 0) {
      formik.handleSubmit();
    } else {
      setShowModal(false);
      setShow(true);
      setText('Creating commission please wait!');
      setType('loading');
      createCommisssion(getbody())
        .then(res => {
          if (res.error) {
            throw new Error(res);
          }
          setShow(false);
          setCurrUnitSelected(formik?.values?.applicable_zone);
        })
        .catch(error => {
          setShow(false);
        });
    }
  };
  useEffect(() => {
    setCurrUnitSelected({});
  }, [showModal]);
  const handleDeleteCommision = () => {
    setLines(lines - 1);
    formik?.setFieldValue(`from${lines - 1}`, '');
    formik?.setFieldValue(`to${lines - 1}`, '');
    formik?.setFieldValue(`comm${lines - 1}`, '');
  };
  return (
    <div className="w-full">
      <PopUp type={type} text={text} show={show} setShow={setShow} />

      <Modal
        show={showModal}
        setShow={setShowModal}
        title={
          <span className="font-bold font-roboto text-xl text-black-1011">
            Add Commission
          </span>
        }
        styleContainer={modalStyle}
      >
        <hr
          className="border-grey-1009 w-full mb-6 -mt-1"
          style={{ borderWidth: '1px' }}
        />
        <div className="grid gap-2 grid-cols-2 mb-4">
          <CommonSelect sort={true}
            options={zoneList}
            {...selectBoxCommonStyle(false)}
            {...selectFiledCommonFormikFunction('applicable_zone')}
          />
          <DropDownLoadingbar status={zoneLoadedStatus} />
        </div>
        <h3 className="text-left text-black-1021 font-medium font-roboto mb-3">
          Choose Product type
        </h3>
        <div className="grid gap-2 grid-cols-2 mb-4">
          <CommonSelect sort={true}
            options={productGroup}
            {...selectBoxCommonStyle(false)}
            {...selectFiledCommonFormikFunction('productGroup')}
          />
          <DropDownLoadingbar status={productGroupLoadStatus} />
        </div>
        <div className="grid gap-2 grid-cols-2 mb-4">
          <CommonSelect sort={true}
            options={products}
            {...selectBoxCommonStyle(false)}
            {...selectFiledCommonFormikFunction('product')}
          />
          <DropDownLoadingbar status={productLoadStatus} />
        </div>
        <div className="w-fulll">
          <h6 className="text-black-1022 font-roboto font-medium  text-xs mb-1">
            Slab (In cr)
          </h6>
          <div className={`w-full overflow-auto ${slabContainer}`}>
            {Array(lines)
              .fill()
              .map((each, i) => (
                <IndSlab
                  commonFormikFunction={commonFormikFunction}
                  index={i}
                  formik={formik}
                  lines={lines}
                />
              ))}
            <div className="w-full flex">
              {lines < 10 && (
                <div
                  className="table  flex mt-2 cursor-pointer  "
                  onClick={() => (lines < 10 ? setLines(lines + 1) : null)}
                >
                  <div className="flex">
                    <img src={AddLine} className="w-5" />
                    <span className="text-green-600 font-medium font-roboto text-xs ml-1">
                      Add Line
                    </span>
                  </div>
                </div>
              )}
              {lines > 1 && (
                <div
                  className="table  flex mt-2 cursor-pointer items-center mr-16 float-right ml-auto"
                  onClick={handleDeleteCommision}
                >
                  <div className="flex">
                    <DeleteForeverIcon style={{ color: 'red' }} />
                    <span className="text-red-500 font-medium font-roboto text-xs ml-1 mt-1">
                      Delete Commission
                    </span>
                  </div>
                </div>
              )}
            </div>

            <div className={`${slabDiv} mt-5`}>
              <InputTypeFloat
                legendName="Max Cap(in lakhs)"
                {...commonFormikFunction(`max_cap`)}
                maxLength={6}
                minLength={0}
                showInText={false}
                handleChange={formik?.handleChange}
              />
            </div>

            <div className="w-full mt-10" onClick={handleSubmit}>
              <button
                type="button"
                className="submitButton text-16 w-56 h-12 font-medium  font-roboto mt-7 "
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const IndSlab = ({ commonFormikFunction, index, formik, lines }) => {
  const handleCommissionchange = e => {
    let splittedValue = e.target.value.toString()?.split('.');

    if (
      !isNaN(e.target.value) &&
      splittedValue &&
      splittedValue[0]?.length < 3
    ) {
      formik?.setFieldValue(`comm${index}`, e.target.value);
    } else {
      return;
    }
  };
  useEffect(() => {
    if (index != 0)
      formik?.setFieldValue(
        `from${index}`,
        formik?.values[`to${index ? index - 1 : 0}`] || 0
      );
  }, []);

  useEffect(() => {
    if (lines > index)
      formik?.setFieldValue(
        `from${index + 1}`,
        formik?.values[`to${index}`] || 0
      );
  }, [formik?.values[`to${index}`]]);

  return (
    <div className="w-full flex my-5">
      <div className="flex items-center">
        <div className={`${slabDiv}`}>
          <InputTypeFloat
            legendName="Min (in cr)"
            {...commonFormikFunction(`from${index}`)}
            maxLength={10}
            minLength={0}
            showInText={false}
            handleChange={formik?.handleChange}
            disabled={true}
            maxValue={100}
          />
        </div>

        <hr
          className="border-grey-1009 mx-1"
          style={{ borderWidth: '1px', width: '15px' }}
        />
      </div>
      <div className={`${slabDiv}`}>
        <InputTypeFloat
          legendName="Max  (in cr)"
          {...commonFormikFunction(`to${index}`)}
          maxLength={10}
          minLength={0}
          showInText={false}
          handleChange={formik?.handleChange}
          maxValue={100}
          legendStyle={{ paddingLeft: '20px' }}
        />
      </div>
      <div className={`${slabDiv} ml-3`}>
        <InputTypeFloat
          {...commonFormikFunction(`comm${index}`)}
          legendName="Commission (%)"
          maxLength={5}
          minLength={0}
          showInText={false}
          handleChange={formik?.handleChange}
          maxValue={100}
          rupeeIcon={false}
          legendStyle={{ paddingLeft: '0px' }}
          onBlurStyle={{ paddingLeft: '0px' }}
        />
      </div>
    </div>
  );
};

const DropDownLoadingbar = ({ status }) => (
  <React.Fragment>
    {status && (
      <div className="relative text-grey-50 z-10 font-normal text-sm pt-px text-md -ml-16 mt-4 w-2">
        {status == 'loading' && (
          <CircularProgress
            style={{ width: '25px', height: '25px' }}
            className="text-teal"
          />
        )}
        {status == 'failed' && (
          <ReportProblemIcon
            style={{ width: '25px', height: '25px', color: 'red' }}
          />
        )}
      </div>
    )}
  </React.Fragment>
);

export default withErrorHandler(AddCommission);
